export default __webpack_public_path__ + "static/media/words7.3cdfc477.png";